export class Base64Writer {
	static B64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
	_base64Buff = ''
	_twoBitQueue = []
	_finalized = false

	writeByte = (byte) => {
		if (this._finalized) {
			console.error('Already finalized!')
			throw new Error("Already finalized!")
		}
		this._twoBitQueue.push((byte >> 6) & 3)
		this._twoBitQueue.push((byte >> 4) & 3)
		this._twoBitQueue.push((byte >> 2) & 3)
		this._twoBitQueue.push(byte & 3)
		while (this._twoBitQueue.length >= 12) {
			this._addB64Chars(4)
		}
	}

	getBase64 = () => {
		if (!this._finalized) {
			this._finalize()
		}
		return this._base64Buff
	}

	_finalize = () => {
		
		if (this._twoBitQueue.length) {
			if (this._twoBitQueue.length === 4) {
				this._twoBitQueue.push(0)
				this._twoBitQueue.push(0)
				this._addB64Chars(2)
				this._base64Buff += '=='
			}
			else if (this._twoBitQueue.length === 8) {
				this._twoBitQueue.push(0)
				this._addB64Chars(3)
				this._base64Buff += '='
			}
		}

		this._finalized = true
	}

	_addB64Chars = cnt => {
		for (let i = 0; i < cnt; i++) {
			const base64Int = (this._twoBitQueue.shift() << 4) + (this._twoBitQueue.shift() << 2) + this._twoBitQueue.shift()
			this._base64Buff += Base64Writer.B64_CHARS.charAt(base64Int)
		}

	}

}